import { createContext } from 'react';
import { GetDocumentsParams } from '@goldwasserexchange/actor/rest-services';

export const documentGetS3ParamsContext = createContext<Partial<GetDocumentsParams>>({});
